import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { ExpandMore, ExpandLess } from '@material-ui/icons';

const ListaExpansivel = ({ classes, itens, itensExpandidos, aoFiltrarItens, aoLimparSelecionados, onToggleExpansao }) => {
  const [itensClicados, setItensClicados] = useState([]);
  const itemRefs = React.useRef([]);
  const [itensExpandidosAnterior, setItensExpandidosAnterior] = useState({});

  const handleComCliqueDoItem = (subItem) => {
    setItensClicados(anterior => {
      const foiClicado = anterior.includes(subItem);
      return foiClicado 
        ? anterior.filter(item => item !== subItem)
        : [...anterior, subItem];
    });
    aoFiltrarItens && aoFiltrarItens(subItem);
  };
 const alternarExpansao = (indice) => {
    const item = itens[indice];
    if (item && item.itens && item.itens.length > 0) {
      onToggleExpansao && onToggleExpansao(indice);
    }
  };

  const handleClearSelected = () => {
    if (itensClicados.length > 0) {
      setItensClicados([]);
      aoLimparSelecionados && aoLimparSelecionados();
    }
  };

  const getUltimoItemQueAlterouStatus = () => {
    const chaves = Object.keys(itensExpandidos);
    for (let chave of chaves) {
      if (itensExpandidos[chave] !== itensExpandidosAnterior[chave]) {
        return chave;
      }
    }
    return null;
  };

  useEffect(() => {
    const ultimoAlterado = getUltimoItemQueAlterouStatus();
    if (ultimoAlterado !== null && itemRefs.current[ultimoAlterado]) {
      itemRefs.current[ultimoAlterado].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    setItensExpandidosAnterior(itensExpandidos);
  }, [itensExpandidos]);




  return (
    <div className={classes.container}>
      <div 
        id="prt-lex-div-lmp"
        className={`${classes.clearButton} ${itensClicados.length === 0 ? classes.clearButtonDisabled : ''}`}
        onClick={handleClearSelected}
      >
        <span className={classes.clearButtonText}>Limpar selecionados</span>
      </div>
      {itens.map((item, indice) => (
        <div key={indice} className={classes.expandableItem} ref={el => itemRefs.current[indice] = el}>
          <div 
            id={`prt-lex-div-hdr-${indice}`}
            className={classes.header}
            onClick={() => alternarExpansao(indice)}
          >
            <div className={classes.titleSection}>
              <span className={classes.icon}>
                {item.icon}
              </span>
              <span className={classes.title}>{item.title}</span>
            </div>
            <div className={classes.rightSection}>
              <span className={classes.quantity}>
                {itensClicados.filter(itemClicado => item.itens.includes(itemClicado)).length} / {item.quantidade}
              </span>
              {itensExpandidos[indice] ? 
                <ExpandLess className={classes.arrow} /> : 
                <ExpandMore className={classes.arrow} />
              }
            </div>
          </div>
          {itensExpandidos[indice] && (
            <div 
              className={classes.content}
            >
              <div className={classes.itemsList} >
                {item.itens && item.itens.map((subItem, subIndice) => (
                  <p 
                    key={subIndice}
                    id={`prt-lex-div-itm-${indice}-${subIndice}`}
                    className={classes.itemText} 
                    style={{ 
                      backgroundColor: itensClicados.includes(subItem) ? item.color : item.secondaryColor, 
                      color: itensClicados.includes(subItem) ? 'white' : item.color, 
                      cursor: 'pointer' 
                    }}
                    onClick={() => handleComCliqueDoItem(subItem)}
                  >
                    {subItem}
                  </p>
                ))}
              </div>
            </div>
          )}
        </div>
      ))}
      </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    height: 'auto',
    overflowY: 'auto'
  },
  expandableItem: {
    border: '1px solid #e0e0e0',
    borderRadius: '8px',
    overflow: 'hidden',
    flexShrink: 0 ,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    cursor: 'pointer',
    backgroundColor: 'white',
    '&:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  titleSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  icon: {
    fontSize: '16px',
    color: '#868686'
  },
  title: {
    fontSize: '14px',
    fontWeight: 500,
    color: '#868686'
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  quantity: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#666'
  },
  arrow: {
    fontSize: '20px',
    color: '#666'
  },
  content: {
    padding: '16px',
    borderTop: '1px solid #e0e0e0',
    backgroundColor: 'white'
  },
  itemsList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: '8px'
  },
  itemText: {
    margin: 0,
    fontSize: '12px',
    fontWeight: 400,
    padding: '2px 8px',
    borderRadius: '15px',
    display: 'inline-block',
    width: 'fit-content'
  },
  clearButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.16)',
    padding: '5px 18px',
    borderRadius: '15px',
    cursor: 'pointer',
    marginBottom: '8px',
    width: 'fit-content',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.08)'
    }
  },
  clearButtonText: {
    fontSize: '16px',
    fontWeight: 600,
    color: 'white'
  },
  clearButtonDisabled: {
    opacity: 0.5,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.16) !important'
    }
  }
};

export default withStyles(styles)(ListaExpansivel);